import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import '../../styles/modals/copyModal.css';

const CopyModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="copy-modal">
      <div className="copy-modal-content">
        <p>Email address has been copied to clipboard</p>
      </div>
    </div>
  );
};

CopyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default CopyModal; 